export default __webpack_public_path__ + "static/media/Monk's Leggings of the Nine Springs.d142ed39.jpg";